import { get, post, put, del } from '@/lib/api/client'
import type {
  ApiResponse,
  PaginatedResponse,
  PaginationParams,
  History,
  CreateHistory,
  UpdateHistory,
  HistoryFilterParams,
  UpdateHistoryStatus,
  HistoryStats
} from '@/lib/api/types'

export const historyService = {
  // Filter histories with pagination
  filterHistories: async (
    params: PaginationParams = { page: 1, size: 10 },
    filters: HistoryFilterParams = {}
  ): Promise<ApiResponse<PaginatedResponse<History>>> => {
    return await post<ApiResponse<PaginatedResponse<History>>>(
      `histories/private/filter?size=${params.size}&page=${params.page}`,
      filters
    )
  },

  // Get history by ID
  getHistoryById: async (historyId: string): Promise<ApiResponse<History>> => {
    return await get<ApiResponse<History>>(`histories/private/${historyId}`)
  },

  // Create a new history
  createHistory: async (data: CreateHistory): Promise<ApiResponse<History>> => {
    return await post<ApiResponse<History>>(
      'histories/admin/private',
      data
    )
  },

  // Update an existing history
  updateHistory: async (
    historyId: string,
    data: UpdateHistory
  ): Promise<ApiResponse<History>> => {
    return await put<ApiResponse<History>>(
      `histories/admin/private/${historyId}`,
      data
    )
  },

  // Delete a history
  deleteHistory: async (historyId: string): Promise<ApiResponse<null>> => {
    return await del<ApiResponse<null>>(
      `histories/admin/private/${historyId}`
    )
  },

  // Search histories
  searchHistories: async (
    params: PaginationParams = { page: 1, size: 10 },
    searchBy?: string
  ): Promise<ApiResponse<PaginatedResponse<History>>> => {
    const queryParams = new URLSearchParams({
      page: params.page.toString(),
      size: params.size.toString()
    })
    
    if (searchBy) {
      queryParams.append('searchBy', searchBy)
    }

    return await get<ApiResponse<PaginatedResponse<History>>>(
      `histories/private/search?${queryParams.toString()}`
    )
  },

  // Update history status
  updateHistoryStatus: async (
    historyId: string,
    data: UpdateHistoryStatus
  ): Promise<ApiResponse<History>> => {
    return await put<ApiResponse<History>>(
      `histories/admin/private/${historyId}/status`,
      data
    )
  },

  // Get history stats
  getHistoryStats: async (): Promise<ApiResponse<HistoryStats>> => {
    return await get<ApiResponse<HistoryStats>>('histories/private/stats')
  }
}

